export const NotFoundPageDE = {
  title: "Seite verschwunden, sie ist.",
  subtitle:
    "Falsche URL gewählt, du hast, junger Padawan. Den Pfad zur richtigen Seite finden, du musst.",
  button: "Zurück zur Startseite",
};
